import React from 'react';
import { ClipboardList, AlertCircle, ExternalLink, CheckCircle } from 'lucide-react';
export function HowToAddCEClasses() {
  return <div className="min-h-screen bg-white pt-40 lg:pt-52 pb-20" data-id="element-923" data-mp="3gov4vajawfm4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-924" data-mp="3bnz3b3mf95jv">
        {/* Page Header */}
        <div className="mb-12" data-id="element-925" data-mp="36qp5p0ovpnky">
          <div className="flex items-center justify-center mb-6" data-id="element-926" data-mp="36pdzyvbvi5r7">
            <ClipboardList className="w-12 h-12 text-brand-purple-600 mr-4" data-id="element-927" data-mp="32okcu4698uzd" />
            <h1 className="text-4xl font-bold text-gray-900" data-id="element-928" data-mp="2xxvlqpyhm00r">
              HOW TO REPORT CLASSES TO ADRE
            </h1>
          </div>
        </div>

        {/* Main Instructions */}
        <div className="mb-12" data-id="element-929" data-mp="2nzfvep7aausb">
          <div className="bg-brand-purple-50 rounded-lg p-8 border-2 border-brand-purple-200 mb-8" data-id="element-930" data-mp="2o07gh6399a4c">
            <h2 className="text-2xl font-bold text-brand-purple-900 mb-4" data-id="element-931" data-mp="2j0l38wnfftvj">
              HOW TO REPORT CE CLASSES AND RENEW YOUR LICENSE
            </h2>
            <p className="text-base text-gray-700 font-semibold mb-2" data-id="element-932" data-mp="2f13w7yscqoo9">
              *Add your current CE classes before proceeding to pay and renew
              your license.
            </p>
            <ul className="list-disc pl-5 text-base text-gray-700 space-y-1" data-id="element-933" data-mp="30hxlpliyjd53">
              <li data-id="element-934" data-mp="2lsjb6a3napo4">
                School is not responsible for reporting your hours to ADRE.
              </li>
              <li data-id="element-935" data-mp="2qnylis2g23fs">Keep your certificates for 5 years.</li>
            </ul>
          </div>

          {/* Step-by-Step Instructions */}
          <div className="space-y-6" data-id="element-936" data-mp="3jeglvlbs9qpi">
            {/* Step 1 */}
            <div className="bg-brand-purple-50 rounded-lg border-2 border-brand-purple-200 p-6" data-id="element-937" data-mp="3jcmbh0y51gzo">
              <div className="flex items-start mb-4" data-id="element-938" data-mp="35h0fuaxefyya">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-939" data-mp="39frc6fu1jckc">
                  1
                </div>
                <div className="flex-1" data-id="element-940" data-mp="1y1m69ha9osmd">
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-941" data-mp="1xz9gihy9pdyr">
                    Click this link to log into your account at ADRE:{' '}
                    <a href="https://ptl.az.gov/dre/#/login" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline inline-flex items-center" data-id="element-942" data-mp="3voodijou8xkg">
                      https://ptl.az.gov/dre/#/login
                      <ExternalLink className="w-4 h-4 ml-1" data-id="element-943" data-mp="3cyq8kcgc7kl1" />
                    </a>
                  </p>
                  <p className="text-sm text-gray-600 mt-2 italic" data-id="element-944" data-mp="37yu308rzrl3d">
                    (Your license number is required to log in. If you do not
                    have it,{' '}
                    <a href="https://services.azre.gov/PdbWeb/IndividualLicense/SearchIndividualLicenses" target="_blank" rel="noopener noreferrer" className="text-brand-purple-600 hover:text-brand-purple-700 font-semibold underline" data-id="element-945" data-mp="1680hz5z8ibnz">
                      click HERE
                    </a>{' '}
                    to obtain your license number)
                  </p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="bg-brand-purple-50 rounded-lg border-2 border-brand-purple-200 p-6" data-id="element-946" data-mp="1ngteih2hkqdp">
              <div className="flex items-start mb-4" data-id="element-947" data-mp="qsn2va75cxpx">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-948" data-mp="us4760au7oti">
                  2
                </div>
                <div className="flex-1" data-id="element-949" data-mp="14rcysmi8crcp">
                  <p className="text-base text-gray-700 leading-relaxed mb-3" data-id="element-950" data-mp="14sekdkwvgw8o">
                    After logging in, under Quick Links (Personal) list, click
                    on <strong data-id="element-951" data-mp="2g5gzscn8jfr9">Manage My Continuing Education</strong>. On the
                    upper left side, find the box and click on{' '}
                    <strong data-id="element-952" data-mp="3p375qk70pcx6">Continuing Education</strong> and then{' '}
                    <strong data-id="element-953" data-mp="3k4vtk2t92qbs">Submit Courses</strong>.
                  </p>
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-954" data-mp="1xzaehqccrtc">
                    On your certificate, find and enter the course number. Use
                    the date on your certificate for Date Started and Date
                    Finished.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className="bg-brand-purple-50 rounded-lg border-2 border-brand-purple-200 p-6" data-id="element-955" data-mp="6v7w2sap7dzc">
              <div className="flex items-start mb-4" data-id="element-956" data-mp="kqthkphq3fn0">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-957" data-mp="gmvlknnp2ky6">
                  3
                </div>
                <div className="flex-1" data-id="element-958" data-mp="pov11bj29gz0">
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-959" data-mp="plpcbxecgh3t">
                    Once your courses are all succesfully recorded, click the
                    blue <strong data-id="element-960" data-mp="1e7nav6ibiz3f">Return Home</strong> button. Under Quick Links
                    (Personal) list, find and click{' '}
                    <strong data-id="element-961" data-mp="zb62mo5fe0l3">Renew My License</strong>. Follow all the prompts,
                    answer YES/NO questionanaire and then pay your license
                    renewal fee.
                  </p>
                </div>
              </div>
            </div>

            {/* Step 4 */}
            <div className="bg-brand-purple-50 rounded-lg border-2 border-brand-purple-200 p-6" data-id="element-962" data-mp="vbdnttpfuy7a">
              <div className="flex items-start mb-4" data-id="element-963" data-mp="gmhkg9ybu9d0">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-purple-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4" data-id="element-964" data-mp="ljhpchjfx62j">
                  4
                </div>
                <div className="flex-1" data-id="element-965" data-mp="bmd1md9y52jm">
                  <p className="text-base text-gray-700 leading-relaxed" data-id="element-966" data-mp="blbrqc4o2m3h">
                    After paying for your new license, print a copy of the
                    confirmation for your records (you may need to provide this
                    confirmation to your broker). Once you renew your license,
                    you and/or your broker may print your license online at the
                    ADRE website.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="space-y-6 mb-12" data-id="element-967" data-mp="2s8085v0kbj6f">
          {/* Important Warning */}
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-lg" data-id="element-968" data-mp="2n8x1k64xp4wc">
            <div className="flex items-start" data-id="element-969" data-mp="2j7llar7y9w0t">
              <AlertCircle className="w-6 h-6 text-yellow-600 mr-3 mt-1 flex-shrink-0" data-id="element-970" data-mp="2j6tml7j23i6b" />
              <p className="text-base text-gray-800" data-id="element-971" data-mp="1bv2z4rz1hvz3">
                <strong data-id="element-972" data-mp="1brozhrhrg0vc">
                  **We suggest that you add your classes directly to ADRE's
                  website.
                </strong>{' '}
                If you send copies of your certificates to ADRE, they can charge
                you an additional $50.00
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}